module.exports = __webpack_public_path__ + "img/educators-day.ba1fd301.webp";